<template>
  <div class="shortcut-item has-down-icon flexible"  @click="$emit('clickDate')">
    <template v-if="start || end">
      {{ startStr }}~{{ endStr }}
    </template>
    <template v-else>
      不限时间
    </template>
  </div>
</template>

<script>
export default {
  name: 'data-range-filter',
  props: {
    start: {
      type: String,
      default: '',
    },
    end: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    startStr: function () {
      return this.start.replace(/-/g, '.');
    },
    endStr: function () {
      return this.end.replace(/-/g, '.');
    },
  },
  methods:{},
  created() {},
};
</script>


